import {Tag, Text, Icon} from '@/components-v2'
import {cn} from '@/helpers/shadcn/utils'
import {OrderChangeTag} from './OrderChangeTag'
import {OrderPositionInput} from './OrderPositionInput'
import {useCatalogSortable} from '../hooks/useCatalogSortable'
import {getCatalogItemName, getOrderItemKey} from '@/containers/Content/ProductCatalog/utils/productCatalogUtils'

export const SubcategoryItem = ({
  subcategory,
  parentId,
  index,
  totalSubcategories,
  onToggleVisibility,
  isEditMode,
  disabled,
  moveItem,
  getOriginalPosition,
  directlyMoved,
  onInputStateChange,
  destination,
}) => {
  const {id, productCount, visible} = subcategory
  const {ref, handleRef, isDragging} = useCatalogSortable({id, parentId, index, disabled: !isEditMode || disabled})
  const subcategoryName = getCatalogItemName(subcategory)
  const itemKey = getOrderItemKey(id, parentId)
  const originalPosition = getOriginalPosition(id, parentId)
  const insertion = destination?.parentId === parentId && destination.id === id ? destination.edge : undefined

  return (
    <div
      ref={ref}
      data-insertion={insertion}
      className={cn(
        'catalog-order-row flex items-center justify-between gap-4 rounded-lg border border-[var(--color-border-default)] p-4',
        isDragging && 'opacity-50'
      )}
    >
      <div className="flex items-center gap-4">
        <button
          type="button"
          ref={handleRef}
          hidden={!isEditMode}
          className="cursor-grab touch-none"
          disabled={!isEditMode || disabled}
        >
          <Icon size="small" icon="drag_indicator" />
        </button>
        {isEditMode ? (
          <OrderPositionInput
            itemKey={itemKey}
            position={index + 1}
            maxPosition={totalSubcategories}
            disabled={disabled}
            onCommit={position => moveItem(id, position, parentId)}
            onInputStateChange={onInputStateChange}
          />
        ) : (
          <Text className={cn('font-semibold', !visible && 'text-gray')}>{index + 1}.</Text>
        )}
        <Text className={cn(!visible && 'text-gray line-through')}>{subcategoryName}</Text>
      </div>
      <div className="flex shrink-0 items-center gap-4">
        <Tag
          text={
            <div className="flex items-center">
              <p>{`${productCount} products`}</p>
              <Icon size="small" icon="chevron_right" />
            </div>
          }
          type="outlined"
          style={{borderColor: '#7DB3FC', color: '#7DB3FC'}}
        />
        {isEditMode ? (
          directlyMoved.has(itemKey) && (
            <OrderChangeTag
              originalPosition={originalPosition}
              position={index + 1}
              disabled={disabled}
              onUndo={() => moveItem(id, originalPosition, parentId)}
            />
          )
        ) : (
          <button
            type="button"
            onClick={onToggleVisibility}
            disabled={disabled}
            className={
              visible ? 'text-[var(--color-feedback-info-high-contrast)]' : 'text-[var(--color-interaction-disabled)]'
            }
          >
            <Icon size="medium" icon={visible ? 'visibility' : 'visibility_off'} />
          </button>
        )}
      </div>
    </div>
  )
}
